import {authHeader} from '../../helpers/index';
import {baseUrl} from '../constants';
import {handleResponse} from './responseHandler';

export const yardService = {};

const apiUrl = baseUrl;

yardService.createYard = (yard) => {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('POST'),
        body: JSON.stringify(yard)
    };

    return fetch(`${apiUrl}/yard`, requestOptions).then(handleResponse);
};

yardService.updateYard = (yard) => {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader('PUT'),
        body: JSON.stringify(yard)
    };

    return fetch(`${apiUrl}/yard/` + yard.id, requestOptions).then(handleResponse);
};

yardService.deleteYard = (yard) => {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader('PUT'),
        body: JSON.stringify(yard)
    };

    return fetch(`${apiUrl}/yard/${yard.id}`, requestOptions).then(handleResponse);
};

yardService.getAll = () => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('GET')
    };

    return fetch(`${apiUrl}/yards`, requestOptions).then(handleResponse)
};

yardService.getYard = (id) => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('GET')
    };

    return fetch(`${apiUrl}/yard/` + id, requestOptions).then(handleResponse);
};
